import { AppMachineContext } from '@/components/Functional/hooks-core/useRaundLifeCycle'
import type { BottomNavigationProps as UIProps } from '@/components/UI/BottomNavigation'
import { useSelector } from '@xstate/react'
import { useTranslation } from 'react-i18next'

/**
 * ボトムナビの「見た目」を決める値（ラベル・GET ボタンのアイコン種別）を返す。
 * 操作可能な BottomNavigation と、表示専用の BottomNavigationPlaceholder で共用し、
 * 両者の見た目がずれないようにする（#3587）。
 */
export const useBottomNavigationDisplay = (): {
  navLabels: UIProps['labels']
  isAllQrCampaign: boolean
} => {
  const { t } = useTranslation()

  // キャンペーンの stampTypes を AppMachineContext から取得
  const appActorRef = AppMachineContext.useActorRef()
  const stampTypes = useSelector(appActorRef, (s) => s.context.campaignData?.stampTypes ?? [])

  // スタンプタイプが QR_CODE のみか判定（空配列は除外）
  const isAllQrCampaign = stampTypes.length > 0 && stampTypes.every((st) => st === 'QR_CODE')

  // UI 層は表示ラベルを持たないため、翻訳済みの文字列をここで組み立てて渡す
  const navLabels = {
    home: t('common.home', 'ホーム'),
    spot: t('common.spot', 'スポット'),
    stamp: 'GET',
    reward: t('bottom_navigation.reward', '特典'),
    mypage: t('bottom_navigation.mypage', '履歴'),
  }

  return { navLabels, isAllQrCampaign }
}
